import React from 'react';

/**
 * In-app support card. Renders the supplied line only. An empty line renders
 * nothing, so no example digits appear when the number source is empty.
 */
const SupportHelpCard = ({ supportLine }) => {
  const line = (supportLine || '').trim();
  if (!line) {
    return null;
  }
  return (
    <aside className="support-help-card" data-support-help-card="true">
      <h2>KeyFlo support</h2>
      <p>{line}</p>
    </aside>
  );
};

export default SupportHelpCard;
